import React from 'react';
import { AnimatePresence as FramerMotionAnimatePresence } from 'framer-motion';
const AnimatePresence = props => {
  return /*#__PURE__*/React.createElement(FramerMotionAnimatePresence, props);
};
AnimatePresence.displayName = 'AnimatePresence';
export default AnimatePresence;
//# sourceMappingURL=AnimatePresence.js.map